import { withStripe } from '../Stripe';
import { StripeCheckoutNewFlow as StripeCheckoutNewFlowComponent } from './StripeCheckoutNewFlow';

export const StripeCheckoutNewFlow = withStripe(StripeCheckoutNewFlowComponent);
